import config from 'config'
import lang from '@/lang'
import { orderStates } from '@/modules/base/util/constants'

const { OPEN, PARTIALLY_CHARGED, PARTIALLY_DELIVERED } = orderStates

const urls = {
  single: 'order',
  multiple: 'orders',
}

const resourceUrl = `${config.resourceHost}order`

export default {
  resourceUrl,
  orderListSetting: `${config.resourceHost}setting/userlist/order`,
  getNewOrder: `${resourceUrl}/new`,
  preview: `${resourceUrl}/preview`,

  getShipmentTypesList: `${config.resourceHost}shipmentType`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
    related: `${config.resourceHost}${urls.multiple}/related`,
  },
  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: {
        state: {
          type: 'set',
          values: [],
        },
      },
    },
    {
      name: 'open',
      title: lang.open,
      quickFilter: {
        state: {
          type: 'set',
          values: [OPEN],
        },
      },
    },
    {
      name: 'partiallyCharged',
      title: lang.orderList.stateLabels.partiallyCharged,
      quickFilter: {
        state: {
          type: 'set',
          values: [PARTIALLY_CHARGED],
        },
      },
    },
    {
      name: 'invoiced',
      title: lang.orderList.stateLabels.invoiced,
      quickFilter: {
        invoicedAt: {
          filterType: 'nullValues',
          type: 'notNull',
        },
      },
    },
    {
      name: PARTIALLY_DELIVERED,
      title: lang.orderList.stateLabels.partiallyDelivered,
      quickFilter: {
        // Filter via the derived deliveryStatus (deliveredAt null + delivery notes exist).
        // Using the deliveryNoteCount column directly triggers the ssr helper to wrap the
        // query in a subquery (COALESCE column), which then breaks the "o"-based order-by.
        deliveryStatus: {
          type: 'set',
          values: [PARTIALLY_DELIVERED],
        },
      },
    },
    {
      name: 'delivered',
      title: lang.orderList.stateLabels.delivered,
      quickFilter: {
        deliveredAt: {
          filterType: 'nullValues',
          type: 'notNull',
        },
      },
    },
  ],
}
